<template>
  <div class="marting-shelf">
    <h3 class="marting-shelf__title title">
      Trabalhamos com as
      <br />
      <strong class="marting-shelf__emphasis">principais seguradoras</strong>
    </h3>
    <ul class="marting-shelf__list">
      <li
        v-for="(insurer, index) in insurers"
        :key="`${insurer.name}_${index}`"
        class="marting-shelf__item"
      >
        <img
          class="marting-shelf__image"
          :src="getLogo(insurer.id)"
          :alt="insurer.alt"
          :title="insurer.title"
          loading="lazy"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "MarketingShelf",
  data() {
    return {
      insurers: [
        {
          id: "bradescoSeguros",
          name: "Bradesco Seguros",
          alt: "Logo da Seguradora Bradesco",
          title: "Bradesco Seguros"
        },
        {
          id: "icatuSeguros",
          name: "Icatu Seguros",
          alt: "Logo da Seguradora Icatu Seguros",
          title: "Icatu Seguros"
        },
        {
          id: "mongeralAegon",
          name: "Mongeral Aegon",
          alt: "Logo da Seguradora Mongeral Aegon",
          title: "Mongeral Aegon"
        },
        {
          id: "portoSeguro",
          name: "Porto Seguro",
          alt: "Logo da Seguradora Porto Seguro",
          title: "Porto Seguro"
        }
      ]
    };
  },
  methods: {
    getLogo: insurerId => require(`../../assets/img/logo-${insurerId}.png`)
  }
};
</script>

<style lang="scss" scoped>
.marting-shelf {
  margin-bottom: $space__hg;

  &__emphasis {
    font-size: 1.1em;
  }
  &__list {
    display: grid;
    grid-template-columns: repeat(2, 50%);
    grid-gap: $space__sm;
    margin: $space__lg 0;
    justify-content: center;

    @include breakpoint($desk__min--sm) {
      grid-template-columns: repeat(4, 25%);
      max-width: 70%;
      margin: 0 auto;
      grid-gap: $space__st;
    }
  }

  &__item {
    @extend %card;
    display: flex;
    margin: 0;
    justify-content: center;

    img {
      max-width: 100%;
    }
  }
}
</style>
